export const DAYS = {
  1: {
    name: "Monday",
    short: "Mon",
  },
  2: {
    name: "Tuesday",
    short: "Tue",
  },
  3: {
    name: "Wednesday",
    short: "Wed",
  },
  4: {
    name: "Thursday",
    short: "Thu",
  },
  5: {
    name: "Friday",
    short: "Fri",
  },
  6: {
    name: "Saturday",
    short: "Sat",
  },
  7: {
    name: "Sunday",
    short: "Sun",
  },
}
